import { RefreshCw } from 'lucide-react';

// Sits behind the feed content and is revealed as the content translates down.
// Mobile only — the desktop feed refreshes on navigation and app-resume.
const PullToRefreshIndicator = ({ pull, progress, armed, refreshing }) => {
  if (pull <= 0 && !refreshing) return null;

  // Fade/scale in over the first half of the pull so a stray few px of
  // overscroll never flashes a full-size chip.
  const appear = Math.min(1, progress * 1.6);

  return (
    <div
      className="absolute left-0 right-0 top-0 flex items-end justify-center pointer-events-none md:hidden"
      style={{ height: Math.max(pull, 0), zIndex: 0 }}
      aria-hidden="true"
    >
      <div
        className="flex items-center justify-center rounded-full mb-2"
        style={{
          width: 32,
          height: 32,
          backgroundColor: 'var(--card-bg)',
          border: '1px solid var(--card-border)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          opacity: appear,
          transform: `scale(${0.7 + appear * 0.3})`,
        }}
      >
        <RefreshCw
          size={16}
          className={refreshing ? 'animate-spin' : ''}
          style={{
            color: armed || refreshing ? 'var(--brand-primary)' : 'var(--text-tertiary)',
            // Wind the icon up as the pull approaches the threshold; once
            // refreshing, animate-spin owns the transform instead.
            transform: refreshing ? undefined : `rotate(${progress * 270}deg)`,
            transition: 'color 0.2s ease',
          }}
          strokeWidth={2.5}
        />
      </div>
    </div>
  );
};

export default PullToRefreshIndicator;
